import { createRouter, createWebHistory } from 'vue-router'

import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition)        return savedPosition
        if (to.hash)              return { selector: to.hash }
        if (from.path === to.path) return {}
        return { top: 0, behavior: 'smooth' }
    },
    routes: [
        {
            path: '/',
            redirect: '/pregled',
        },
        {
            path:      '/prijava',
            name:      'prijava',
            component: () => import('@/views/Prijava.vue'),
            meta:      { layout: 'Blank', requiresAuth: false },
        },
        {
            path:      '/ni-dostopa',
            name:      'ni-dostopa',
            component: () => import('@/views/NiDostopa.vue'),
            meta:      { layout: 'Blank', requiresAuth: false },
        },
        { path: '/pregled',            name: 'pregled',            component: () => import('@/views/pregled/Pregled.vue'),                 meta: { requiresAuth: true } },
        { path: '/projekti',            name: 'projekti',            component: () => import('@/views/projekti/Projekti.vue'),                meta: { requiresAuth: true } },
        { path: '/kakovost',            name: 'kakovost',            component: () => import('@/views/kakovost/Kakovost.vue'),                meta: { requiresAuth: true } },
        { path: '/prihodki-stroski',    name: 'prihodki-stroski',    component: () => import('@/views/prihodki/PrihodkiStroski.vue'),         meta: { requiresAuth: true } },
        { path: '/denarni-tok',         name: 'denarni-tok',         component: () => import('@/views/tok/DenarniTok.vue'),                   meta: { requiresAuth: true } },
        { path: '/placilna-disciplina', name: 'placilna-disciplina', component: () => import('@/views/disciplina/PlacilnaDisciplina.vue'),    meta: { requiresAuth: true } },
        { path: '/uvozi',               name: 'uvozi',               component: () => import('@/views/uvozi/Uvozi.vue'),                      meta: { requiresAuth: true } },
        { path: '/napredek-projektov',  name: 'napredek-projektov',  component: () => import('@/views/napredek/NapredekProjektov.vue'),    meta: { requiresAuth: true } },
        { path: '/ekipe',               name: 'ekipe',               component: () => import('@/views/ekipe/Ekipe.vue'),                      meta: { requiresAuth: true } },
        { path: '/prodaja',             name: 'prodaja',             component: () => import('@/views/prodaja/Prodaja.vue'),                  meta: { requiresAuth: true } },
        { path: '/:pathMatch(.*)*', redirect: '/pregled' },
    ],
})

// Every route is PROTECTED unless it opts out with `requiresAuth: false` — a route that
// forgets its meta must fail closed (login page), not open (admin UI with failing calls).
router.beforeEach((to) => {
    const appStore = useAppStore()
    const loggedIn = appStore.isLoggedIn()

    // With `?code` the sign-in page goes on: it finishes the OAuth flow (Prijava.vue).
    if (loggedIn && to.name === 'prijava' && !to.query.code) return { name: 'pregled' }
    if (to.meta.requiresAuth !== false && !loggedIn) {
        appStore.setLogout()   // clears an expired token so the next check is clean
        return { name: 'prijava', query: to.fullPath !== '/' ? { redirect: to.fullPath } : {} }
    }
})

export default router
